import { render } from "./SupplierDuplicateDialog.vue?vue&type=template&id=41b9b625&scoped=true"
import script from "./SupplierDuplicateDialog.vue?vue&type=script&lang=ts"
export * from "./SupplierDuplicateDialog.vue?vue&type=script&lang=ts"

import "./SupplierDuplicateDialog.vue?vue&type=style&index=0&id=41b9b625&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-41b9b625"

export default script
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QBtn,QDialog});
